var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "tos-form" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-file-text-o" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert alert-info my-4" }, [
        _c("p", {
          staticClass: "m-0",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("tos.description.content", {
                univers: _vm.Utils().getApplicationName(),
              })
            ),
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c("UiCard", [
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-4" }, [
                  _vm._v(_vm._s(_vm.$t("tos.form.title"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tos.title,
                      expression: "tos.title",
                    },
                    { name: "validate", rawName: "v-validate" },
                  ],
                  staticClass: "form-input col",
                  attrs: {
                    type: "text",
                    name: "title",
                    "data-vv-rules": "required",
                    "data-vv-as": _vm.$t("identification.title"),
                    "data-vv-validate-on": "none",
                  },
                  domProps: { value: _vm.tos.title },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.tos, "title", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.showErrors["title"] && _vm.errors.has("title"),
                        expression:
                          "showErrors['title'] && errors.has('title')",
                      },
                    ],
                    staticClass: "form-input-error",
                    on: {
                      click: function ($event) {
                        return _vm.hideError("title")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.errors.first("title")))]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row row" }, [
                _c("label", { staticClass: "col-4" }, [
                  _vm._v(_vm._s(_vm.$t("tos.form.active")) + "\n            "),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        position: "relative",
                        "margin-left": "10px",
                      },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa fa-question-circle text-warning warning-beepiz-remote-monitoring show",
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tooltip left",
                          staticStyle: {
                            width: "250px",
                            top: "-2px",
                            left: "37px",
                          },
                        },
                        [
                          _c(
                            "h5",
                            {
                              staticStyle: {
                                color: "#ffc107",
                                "font-weight": "700",
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("tos.tooltip.title")) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("tos.tooltip.content", {
                                  univers: _vm.Utils().getApplicationName(),
                                })
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col", staticStyle: { padding: "0" } },
                  [
                    _c("UiSwitch", {
                      model: {
                        value: _vm.tos.active,
                        callback: function ($$v) {
                          _vm.$set(_vm.tos, "active", $$v)
                        },
                        expression: "tos.active",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-8 full-height" },
          [
            _c("UiCard", [
              _c(
                "div",
                { staticClass: "form-row row full-height" },
                [
                  _c("UiEditor", {
                    ref: "editor",
                    staticClass: "col-12 full-height",
                    attrs: {
                      contentparent: _vm.tos.content,
                      isInvalid: _vm.showErrors.content,
                    },
                    on: { eventEditorUpdated: _vm.contentEditorUpdated },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showErrors["content"] &&
                            _vm.errors.has("content"),
                          expression:
                            "showErrors['content'] && errors.has('content')",
                        },
                      ],
                      staticClass: "form-input-error",
                      staticStyle: {
                        bottom: "auto",
                        top: "-10px",
                        right: "30px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.hideError("content")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("content")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-4 d-flex justify-content-between" },
              [
                _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.forceDisplay,
                        expression: "forceDisplay",
                      },
                    ],
                    attrs: {
                      id: "checkbox-force-display",
                      type: "checkbox",
                      disabled: !_vm.tos.active,
                    },
                    domProps: {
                      checked: Array.isArray(_vm.forceDisplay)
                        ? _vm._i(_vm.forceDisplay, null) > -1
                        : _vm.forceDisplay,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.forceDisplay,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.forceDisplay = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.forceDisplay = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.forceDisplay = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      class: ["pl-2", !_vm.tos.active ? "text-black-50" : ""],
                      attrs: { for: "checkbox-force-display" },
                    },
                    [_vm._v(_vm._s(_vm.$t("tos.form.forceDisplay")))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "Btn",
                  {
                    staticClass: "primary",
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.validForm($event)
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("global.save")))])]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }